import http from "./http";
import Service from "../Service";

/**
 * @type CategoryService
 */
export default class CategoryService extends Service {

	list() {
		return http.get(`/admin/categories`, {
			headers: this.getHeaders()
		});
	}
}
